import React from 'react';
import { FieldProps } from '../../../components/Fields/Types';
import UserDefinedField from '../../../components/Fields/UserDefinedField';
import UserDefinedFieldValueModel from '../../../models/UserDefinedFieldValueModel';
import WorkflowTaskSetCustomFieldsModel from '../../../models/WorkflowTaskSetCustomFieldsModel';

interface IProps {
    formData: WorkflowTaskSetCustomFieldsModel
    getFieldProps: (fieldName: string) => FieldProps
}

const TaskSetCustomFieldsView: React.FC<IProps> = ({ formData, getFieldProps }) => {
    console.log(formData);

    var fields = formData.userDefinedFields.map((udf: UserDefinedFieldValueModel, udfIndex: number) => {
        return (
            <UserDefinedField
                {...getFieldProps(`workflowTaskSetCustomFieldsModel.userDefinedFields.${udfIndex}.value`)}
                userDefinedFieldValue={udf}
                visible={true}
                key={`${udfIndex}`}
            />
        );
    });

    return (<>{ fields }</>);
}
export default TaskSetCustomFieldsView;